import React, { PropsWithChildren, useState } from 'react';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';

const SitrepToggleSection: React.FC<PropsWithChildren> = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="m-2">
      <StylishNewButton
        className="button--secondary"
        type="button"
        aria-expanded={isVisible}
        onClick={() => setIsVisible((prev) => !prev)}
      >
        {isVisible ? 'Hide SITREP' : 'Show SITREP'}
      </StylishNewButton>
      {isVisible && <div className="m-2">{children}</div>}
    </div>
  );
};

export default SitrepToggleSection;
